import { useState, useEffect } from 'react'
import * as XLSX from 'xlsx'
import { api } from '../services/api'

const TIPO_LABEL = {
  exclusao_usuario: 'Exclusão de usuário',
  edicao_cliente:   'Edição de cliente',
}

const TIPO_COR = {
  exclusao_usuario: 's-cancelado',
  edicao_cliente:   's-assinado',
}

const formatarDataHora = iso => {
  if (!iso) return '—'
  const d = new Date(iso)
  return d.toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })
}

function exportarLogExcel(logs) {
  const rows = logs.map(l => ({
    'Data/Hora':      formatarDataHora(l.created_at),
    'Ação':           TIPO_LABEL[l.tipo] || l.tipo,
    'Executado por':  l.executado_por_nome || '',
    'Alvo':           l.alvo_descricao || '',
    'Justificativa':  l.justificativa || '',
  }))
  const ws = XLSX.utils.json_to_sheet(rows)
  ws['!cols'] = [{ wch: 18 }, { wch: 22 }, { wch: 28 }, { wch: 40 }, { wch: 50 }]
  const wb = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(wb, ws, 'Log')
  XLSX.writeFile(wb, `log_sistema_${new Date().toISOString().slice(0, 10)}.xlsx`)
}

export default function Logs() {
  const [logs, setLogs] = useState([])
  const [loading, setLoading] = useState(true)
  const [erro, setErro] = useState('')

  useEffect(() => {
    api.logs.listar()
      .then(setLogs)
      .catch(e => setErro(e.message))
      .finally(() => setLoading(false))
  }, [])

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' }}>
        <h1 style={{ fontSize: '20px', fontWeight: 'normal', letterSpacing: '0.06em', margin: 0, color: 'var(--text-primary)' }}>
          LOG DO SISTEMA
        </h1>
        <button
          onClick={() => exportarLogExcel(logs)}
          disabled={logs.length === 0}
          className="btn-green"
          style={{ fontSize: '12px', padding: '7px 16px' }}
        >
          Exportar Excel
        </button>
      </div>

      <div className="card">
        {loading ? (
          <p style={{ color: 'var(--text-secondary)', margin: 0 }}>Carregando...</p>
        ) : erro ? (
          <div className="badge-err">{erro}</div>
        ) : logs.length === 0 ? (
          <p style={{ color: 'var(--text-secondary)', margin: 0 }}>Nenhum registro no log ainda.</p>
        ) : (
          <table>
            <thead>
              <tr>
                {['Data/Hora', 'Ação', 'Executado por', 'Alvo', 'Justificativa'].map(h => <th key={h}>{h}</th>)}
              </tr>
            </thead>
            <tbody>
              {logs.map(l => (
                <tr key={l.id}>
                  <td style={{ whiteSpace: 'nowrap', color: 'var(--text-secondary)', fontSize: '13px' }}>{formatarDataHora(l.created_at)}</td>
                  <td>
                    <span className={`sb ${TIPO_COR[l.tipo] || 's-cancelado'}`}>
                      {TIPO_LABEL[l.tipo] || l.tipo}
                    </span>
                  </td>
                  <td style={{ fontWeight: 'bold' }}>{l.executado_por_nome}</td>
                  <td style={{ fontSize: '13px', color: 'var(--text-primary)' }}>{l.alvo_descricao}</td>
                  <td style={{ fontSize: '13px', color: 'var(--text-secondary)', maxWidth: '280px' }}>{l.justificativa}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  )
}
